exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {\n  overflow: unset;\n}\n", ""]);

// exports
